import styled from 'styled-components';
import Stack from 'src/components/widgets/stack/stack';
import { ComposerInputArea } from 'src/components/shared/aiAssistant/conversationPrimitives';
import { ChatContainer } from 'src/components/shared/aiAssistant';
import { FullscreenLayout, FullscreenIframeTopBar } from 'src/components/widgets/fullscreenIframeLayout';

export const Page = styled(FullscreenLayout)`
    background: linear-gradient(160deg, #fdfcff 0%, #faf8ff 50%, #fffafc 100%);
    overflow: hidden;
`;

export const TopBar = styled(FullscreenIframeTopBar)`
    gap: 16px;
    box-sizing: border-box;
    @media (max-width: 600px) {
        padding: 12px 16px;
        gap: 10px;
    }
`;

export const Identity = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 0;
    > div {
        min-width: 0;
    }
    h1 {
        margin: 0;
        font-size: 16px;
        font-weight: 600;
        background: ${(p) => p.theme.ai.gradientHorizontal};
        background-clip: text;
        -webkit-text-fill-color: transparent;
    }
    p {
        margin: 3px 0 0;
        font-size: 12px;
        color: #6b7280;
    }
    @media (max-width: 600px) {
        h1 {
            font-size: 14px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        p {
            display: none;
        }
    }
`;

export const AgentIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    flex-shrink: 0;
    border-radius: 12px;
    background: ${(p) => p.theme.ai.surface};
    color: ${(p) => p.theme.ai.solid};
    @media (max-width: 600px) {
        display: none;
    }
`;

export const HeaderActions = styled(Stack)`
    margin-left: auto;
    flex-direction: row;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
    @media (max-width: 600px) {
        gap: 6px;
    }
`;

export const HistoryAnchor = styled.div`
    position: relative;

    > aside {
        left: auto;
        right: 0;
        @media (max-width: 600px) {
            position: fixed;
            top: 64px;
            right: 12px;
            max-width: calc(100vw - 24px);
        }
    }
`;

export const Workspace = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    min-width: 0;
    padding: 0 0 20px;
    @media (max-width: 600px) {
        padding: 0 0 12px;
    }
`;

export const Chat = styled(ChatContainer)`
    gap: 18px;
    padding: 4px max(24px, calc((100% - 850px) / 2)) 24px;
    box-sizing: border-box;
    @media (max-width: 600px) {
        padding-left: 16px;
        padding-right: 16px;
    }
`;

export const ComposerFrame = styled(Stack)`
    width: calc(100% - 48px);
    max-width: 850px;
    margin: 0 auto;
    flex-shrink: 0;
    gap: 10px;
    @media (max-width: 600px) {
        width: calc(100% - 32px);
    }
`;

export const Composer = styled(ComposerInputArea).attrs({ as: 'form' })`
    background: ${(p) => p.theme.app.backgroundColorBase};
`;

export const AttachmentList = styled.ul`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    list-style: none;
    padding: 0;
    margin: 0;
    li {
        display: flex;
        align-items: center;
        gap: 8px;
        overflow-wrap: anywhere;
    }
`;

export const HiddenInput = styled.input`
    display: none;
`;

export const Notice = styled.p<{ $error?: boolean }>`
    margin: 0;
    color: ${(p) => (p.$error ? '#b42318' : '#60606d')};
    font-size: 14px;
`;
